export default __webpack_public_path__ + "static/media/select_clinic_bg_image.d6ccdd33.png";